import React from 'react';
import LogoutComponent from '@/components/pages/Logout';

export default function Logout() {
  return (
    <><LogoutComponent /></>
  );
}